import chapterClass from "@/class/interactive-image/chapter"
import store from "@/store/store";
import Tools from "@/class/tools";
import {viewModel} from "@/class/view-model";
import {volets} from "@/class/volets";
import {Media} from "@/class/data-type";

/*
 * L'objet InteractiveImage contient l'intégralité des informations de l'interactive image (chapitre, labels, data, ect...)
 * Lors d'un Cancel sur l'interactiveImage (function restore) l'intégralité des informations sont restoré (chapitre, label, data, etc..)
 * l'historique est gérer par this.history
 */

export class interactiveImage extends viewModel{
    
    objectType = "interactive_image";
    
    data = [
        {name: "name", type: String, default: "A renseigner"},
        {name: "type", type: String, default: "pan_zoom"},
        {name: "intro_title", type: String, default: "New Interactive Image"},
        {name: "intro_subtitle", type: String, default: ""},
        {name: "intro_text", type: String, default: ""},
        {name: "width", type: Number, default: 0},
        {name: "height", type: Number, default: 0},
        {name: "bounding_box", type: Array, default: [[0,0],[0,0]]},
        {name: "bounding_box_pan_horizontal", type: String, default: "left"},
        {name: "bounding_box_pan_vertical", type: String, default: "top"},
        {name: "display_chapters_titles", type: Boolean, default: true},
        {name: "label_color", type: String, default: ""},
        {name: "background_color", type: String, default: ""},
        {name: "hide_back_button", type: Boolean, default: false},
        {name: "hide_intro", type: Boolean, default: false},
        {name: "chapter_fade_behaviour", type: String, default: "additive"},
        {name: "intro_image", type: Media, default: new Media({type:"picture"})},
        {name: "base_image", type: Media, default: new Media({type:"picture"})},
    ]
    
    chapters = [new chapterClass()];
    
    /**
     * variables de fonctionnement
     */
    
    volets = new volets().set([
        {label: "Labels", component: "InteractiveImage_Labels"},
        {label: "Introduction", component: "InteractiveImage_Introduction"},
        {label: "Chapters", component: "InteractiveImage_Chapters"},
        {label: "Settings", component: "InteractiveImage_Image"},
    ]);
    
    currentType = "all";
    currentChapterKey = 0;
    backgroundColorVisible = false;
    

    constructor() {
        super();
        this.init();
    }
    
    setId(pk) {
        super.setId(pk);
        this.chapters.forEach((chap) => {
            chap.interactive_image = pk
        })
    }
    setStoryId(pk) {
        super.setStoryId(pk);
        this.chapters.forEach((chap) => {
            chap.setStoryId(pk)
        })
    }
    
    async setDataReq(data, preview) {
        super.setDataReq(data, preview);
    
        if(data.chapters) {
           await this.setChapters(data.chapters, !preview);
        }
    
        // this.ongletSet()
    }

    async setChapters(chapters, load = true) {
        this.chapters = [];
        
        let promises = [];
    
        chapters.forEach((chapter,key) => {
            
            let chap = new chapterClass();
            chap.setStoryId(this.getStoryId());
            chap.setDataReq(chapter);
    
            this.chapters.push(chap);
            
            if(load) {
                promises.push(chap.load());
                
                if(key === 0) {
                    promises.push(this.chapters[0].loadImage())
                }
            }
    
        })
        
        return Promise.all(promises)
    }
    
    getChapter(key) {
        return this.chapters[key];
    }
    
    getThumbnail(){
        if(this.chapters[0] && this.chapters[0].base_image.hasMedia()) return this.chapters[0].getBaseImage();
        return this.base_image.media || store.getters.getDefault("BaseImage");
    }
    getBaseImage(){
        return this.base_image.media;
    }
    getIntroImage(){
        return this.intro_image.media;
    }
    
    addEmptyChapter() {
        let chapter = new chapterClass().setStoryId(this.getStoryId()).setDataReq({
            pk : -new Date().getTime(),
            interactive_image : this.getId(),
            title : "New Chapter",
            base_image : "",
            order : this.chapters.length
        }).edit()
        
        chapter.save(false);
        
        this.chapters.push(chapter);
        
        return this.chapters.length - 1;
    }
    
    async save(saveChapters = false) {
        if(!await super.save()){
            return false;
        }
        
        if(saveChapters){
            if(!await this.saveChapters(true)){
                return false;
            }
        }
        
        return true;
    }
    
    async saveChapters(saveLabels) {
        
        let promises = [];
        this.chapters.map((chapter) => {
            promises.push(
                chapter.save(saveLabels)
            );
        });
        
        await Promise.all(promises)
        
        return true;
    }
    
    
    isValideBaseImage(){
        return this.width > 1 && this.height > 1;
    }
    
    /**
     * Function de fonctionnement
     */

    typeGet(){
        return this.currentType;
    }
    
    typeSet(type){
        this.currentType = type;
        console.log(this.currentType)
    }
    

    chaptersReset(){
        this.chapters = [];
        return this;
    }
    chapterHas(){
        return this.chapters.length > 0
    }
    chaptersGet(){
        return this.chapters;
    }
    chapterGet(key){
        return this.chapters[key];
    }
    chapterIsActive(key){
        return key === this.currentChapterKey;
    }
    chapterKey(){
        return this.currentChapterKey
    }
    chapterGetCurrent(){
        if(this.chapters.length <= 0) return new chapterClass().fake();
        return this.chapters[this.currentChapterKey];
    }
    chaptersGetSaved(){
        return this.chapters.filter(c => !c.isNew())
    }
    chapterGetById(id){
        return this.chapters.filter(c => c.getId() === id)[0]
    }
    chapterSetActive(key,resetUi){
        this.currentChapterKey = key;
        if(resetUi) {
            this.currentType = "all";
            this.volets.setActive(0);
        }
        
        if(this.typeGet() === "boundingzoom"){
            this.boundinZoneShow()
        }
    }
    chapterAdd(){
        // s'il y a déjà un autre chapitre en cours de création on annule
        if(this.chapters.filter(c => c.getId() <= 0).length > 0){
            return;
        }
        this.chapterGetEditing().unedit()
        this.addEmptyChapter();
        this.volets.setActive(2);
    }
    chapterEdit(key){
        this.chapterGetEditing().unedit()
        this.chapters[key].edit()
    }
    chapterUnedit(key){
        this.chapterGetEditing().unedit()
    }
    chapterIsEditing(key){
        return this.chapters[key].isEditing
    }
    chapterGetEditing(){
        return this.chapters.find(c => c.isEditing) || new chapterClass().fake()
    }
    chapterHasEditing(){
        return this.chapterGetEditing().valide()
    }
    chapterGetImages(){
        let images = [];
        
        images.push(this.base_image.media)
    
        if(this.chapters.length <= 0){
            return images;
        }
        if(this.chapter_fade_behaviour === "additive") {
            for (let i = 0; i <= this.currentChapterKey; i++) {
                images.push(this.chapters[i].getBaseImage())
            }
        }
        if(this.chapter_fade_behaviour === "sequential") {
            images.push(this.chapters[this.currentChapterKey].getBaseImage())
        }
        return images;
    }
    chaptersGetData(){
        let datas = []
        this.chapters.forEach((c) => {
            datas.push(c.getData())
        })
        return datas;
    }
    
    labelsGet(){
        if (this.typeGet() === 'all') {
            return this.chapterGetCurrent().getAllLabel();
        }
    
        return this.chapterGetCurrent().getLabelsByType(this.typeGet());
    }
    labelsGetReverse(){
        let labels = this.labelsGet()
        labels.sort((l1,l2) => {
            if(!l1.isEditing && !l2.isEditing) return 0;
            if(l1.isEditing && !l2.isEditing) return -1;
            if(!l1.isEditing && l2.isEditing) return 1;
        })
        labels.reverse()
        return labels
    }
    labelsGetAll(){
        let labels = [];
        this.chapters.forEach(c => {
            c.getAllLabel().forEach(l => {
                labels.push(l)
            })
        })
        return labels
    }
    labelGetSelect(){
        return this.labelsGet().find((l) => l.isSelected)
    }
    labelGetEdit(){
        return this.labelsGet().find((l) => l.isEditing)
    }
    labelAdd(type){
        let label = Tools.clone(store.getters.labelsDefault(type));
    
        label.pk = - new Date().getTime();
        label.x_coord = this.width / 2
        label.y_coord = this.height / 2
        label.order = 9999
    
        label = this.chapterGetCurrent().addLabel(type, label);
        
        this.chapterGetCurrent().orderLabels(this.chapterGetCurrent().getAllLabel())
        
        if (this.typeGet() !== type && this.typeGet() !== "all") {
            this.typeSet(type)
        }
        
        this.labelUnselect();
        this.labelUnedit();
    
        label.edit();
        label.select();
    
        if(type === "area"){
            label.draw()
        }
    
        this.labelsGet().forEach((label) => {
            label.save(false);
        })
        return label;
    }
    labelSelect(label){
        if(this.labelHasEdit()){
            return;
        }
        
        this.labelUnselect();
        label.select();

        // if(this.labelHasEdit()){
        //     this.labelUnedit();
        //     label.edit();
        // }
    }
    labelUnselect(){
        this.labelsGet().map((l) => l.unselect());
    }
    labelEdit(label){
        this.labelUnselect();
        this.labelUnedit()
        label.select();
        label.edit();
    }
    labelUnedit(){
        this.labelsGet().map((l) => l.unedit());
    }
    labelHasEdit(){
        return this.labelsGet().find((l) => l.isEditing)
    }
    labelLeave(){
        this.labelsGet().map((l) => l.leave());
    }
    labelIsDraw(){
        if(!this.labelGetSelect()) {
            return false;
        }
        return this.labelGetSelect().isDrawing;
    }
    
    boundinZoneShow(){
        
        let type = "boundingzoom"
        let label = Tools.clone(store.getters.labelsDefault("boundingzoom"));
    
        label.pk = - new Date().getTime();
        console.log(this.bounding_box)
        if(!this.bounding_box[0]){
            this.bounding_box = [[0,0],[0,0]]
        }
        
        label.x_coord = this.bounding_box[0][0];
        label.y_coord = this.bounding_box[0][1];
    
        label.width = this.bounding_box[1][0] - this.bounding_box[0][0];
        label.height = this.bounding_box[1][1] - this.bounding_box[0][1];
        label.panType = this.type;
        
        label = this.chapterGetCurrent().addLabel(type, label);
    
        // this.chapterSetActive(0,true);
        this.typeSet(type);
    
        this.labelUnselect();
        this.labelUnedit();
    
        label.edit();
        label.select();
        
        return label;
    }
    boundingZoneGet(){
        return this.chapterGetCurrent().boundingzooms[0];
    }
    
    backgroundColorShow(){
        return this.backgroundColorVisible;
    }
}